import React from 'react';
import { Sidebar } from '../components/Sidebar';
import { RankAListSteps } from '../components/RankAListSteps';

const RankAList = () => {
  return (
    <div className="min-h-screen bg-slate-900 text-white flex">
      {/* Fixed Sidebar */}
      <Sidebar />

      {/* Main Content with margin to account for fixed sidebar */}
      <div className="flex-1 flex flex-col ml-64">
        {/* Fixed Header */}
        <div className="p-6 border-b border-slate-700 bg-slate-900 fixed top-0 right-0 left-64 z-10">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-white">Rank a List</h1>
              <p className="text-slate-400 mt-1">Rank your target accounts using AI + AlphaLoop's proprietary data with up to 1,000 unique company signals.</p>
            </div>
          </div>
        </div>

        {/* Content with margin to account for fixed header */}
        <div className="mt-32 h-[calc(100vh-8rem)] overflow-y-auto">
          <div className="p-6">
            <RankAListSteps />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RankAList; 